import React from 'react';
import { motion } from 'framer-motion';
const BONUS = [{
  num: 1,
  title: 'Planificador Semanal Docente',
  desc: 'Tu semana de clases organizada en una sola hoja imprimible. Nunca más llegues sin saber qué dar el lunes.',
  price: '$6.000'
}, {
  num: 2,
  title: 'Plantillas de Seguimiento de Alumnos',
  desc: 'Fichas individuales, planilla grupal y registro de asistencia. Sabés exactamente cómo va cada alumno en todo momento.',
  price: '$5.000'
}, {
  num: 3,
  title: 'Aula Lista em 10 Min',
  desc: '12 actividades de inicio, 10 exit tickets y 6 cierres de clase listos. Cualquier clase en marcha en 10 minutos exactos.',
  price: '$7.000'
}, {
  num: 4,
  title: 'Guía Exam-Ready',
  desc: 'Nivelómetro de 15 minutos para ubicar a cualquier alumno nuevo + banco de 50 feedbacks profesionales en portugués listos para usar.',
  price: '$8.000'
}, {
  num: 5,
  title: 'Módulos VIP Negocios & Viajeros',
  desc: '5 módulos de portugués corporativo: reuniones, emails, negociación, entrevistas y survival Brazil. Para clientes de alto valor.',
  price: '$9.000'
}, {
  num: 6,
  title: 'O Mundo Português — Inmersión Cultural',
  desc: 'Playlists por nivel, guía de cine, diccionario de gírias brasileñas, 10 curiosidades quebra-gelo y guía para organizar una Noite Brasileira.',
  price: '$6.000'
}];
export function BonusGrid() {
  return <section className="w-full bg-light-gray py-20 px-4" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <div className="text-center mb-16" data-id="element-20">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-deep-green mb-4" data-id="element-21">
            Más los 6 Bonus Estratégicos
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-500 mb-4" data-id="element-22">
            Incluidos en todas las ofertas — sin costo extra
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="inline-block bg-gold/20 text-gold-700 font-bold px-6 py-2 rounded-full text-sm md:text-base border border-gold/30" data-id="element-23">
            🎁 GRATIS sólo por hoy — incluidos con tu compra
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-24">
          {BONUS.map((bonus, i) => <motion.div key={bonus.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all p-8 relative border border-gray-100" data-id="element-25">
              <div className="absolute -top-4 -left-4 w-10 h-10 bg-gold text-deep-green font-bold rounded-full flex items-center justify-center shadow-lg border-2 border-white" data-id="element-26">
                {bonus.num}
              </div>

              <div className="flex items-start gap-4 mb-4" data-id="element-27">
                <span className="text-3xl mt-1" data-id="element-28">🎁</span>
                <div data-id="element-29">
                  <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-30">
                    BONUS {bonus.num}
                  </div>
                  <h3 className="text-xl font-bold text-deep-green leading-tight" data-id="element-31">
                    "{bonus.title}"
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-32">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-100" data-id="element-33">
                <span className="text-gray-400 line-through text-sm font-medium" data-id="element-34">
                  {bonus.price}
                </span>
                <span className="text-green-600 font-bold" data-id="element-35">→ GRATIS</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-xl mx-auto bg-deep-green rounded-2xl p-8 text-center shadow-xl" data-id="element-36">
          <div className="text-green-100 font-medium mb-2 tracking-wide text-sm" data-id="element-37">
            VALOR TOTAL DE LOS 6 BONUS
          </div>
          <div className="text-gray-400 line-through text-2xl font-bold mb-2" data-id="element-38">
            $41.000
          </div>
          <div className="text-white text-xl font-bold" data-id="element-39">
            🎁 GRATIS — Incluidos en todas las ofertas. Siempre.
          </div>
        </motion.div>
      </div>
    </section>;
}